{
  "name": "@nufi/dapp-client-core",
  "version": "0.7.1",
  "license": "MIT",
  "homepage": "https://github.com/nufi-official/dapp-client/tree/master/core",
  "repository": {
    "type": "git",
    "url": "git://github.com/nufi-official/dapp-client.git"
  },
  "type": "module",
  "main": "dist/index.js",
  "types": "dist/index",
  "files": [
    "src",
    "!src/__tests__",
    "dist",
    "!dist/.tsbuildinfo",
    "!dist/**/*.ts.map",
    "!dist/**/*.cts.map"
  ],
  "exports": {
    ".": {
      "require": {
        "types": "./dist/index.d.cts",
        "default": "./dist/index.cjs"
      },
      "import": {
        "types": "./dist/index.d.ts",
        "default": "./dist/index.js"
      }
    },
    "./package.json": "./package.json"
  },
  "scripts": {
    "build": "rm -rf dist && tsup --onSuccess 'yarn build:declarationMap'",
    "watch": "tsup --watch --onSuccess 'yarn build:declarationMap'",
    "build:declarationMap": "tsc --emitDeclarationOnly --declarationMap",
    "test:tsc": "tsc --noEmit",
    "test:unit": "NODE_ENV=jest run -T jest -c jest/jest.unit.config.cjs --forceExit",
    "test": "yarn test:tsc && yarn test:unit",
    "prepublish": "yarn test",
    "prepack": "yarn build"
  },
  "devDependencies": {
    "@metamask/providers": "^17.1.2",
    "@types/jest": "^29.5.12",
    "esbuild-plugin-file-path-extensions": "^2.1.4",
    "jest": "^29.7.0",
    "ts-jest": "^29.1.2",
    "tsup": "^8.5.0",
    "typescript": "^5.5.3"
  },
  "packageManager": "yarn@4.10.3"
}
